<script>
  import bootbox from '../../bootbox.min';
  import IntersectionObserver from '../../intersection-observer-polyfill';

  export default {
    template: '#data-list',

    props: {
      canEdit: Boolean,

      dataSource: {
        type: String,
      },

      identifier: {
        default: '',
      },

      urlCreate: {
        type: String,
        default() {
          return null;
        },
      },

      deleteMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja apagar este registro?';
        },
      },

      resendMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja reenviar este e-mail?';
        },
      },

      undeleteMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja restaurar este usuário?';
        },
      },

      deleteTitle: {
        type: String,
        default() {
          return 'Excluir registro';
        },
      },

      resendTitle: {
        type: String,
        default() {
          return 'Reenviar e-mail';
        },
      },

      undeleteTitle: {
        type: String,
        default() {
          return 'Restaurar';
        },
      },

      filterType: {
        default: () => 'print',
      },

      handleSelectedUrl: {
        required: false,
      }
    },

    watch: {
      checkAll(checkAll) {
        this.selectedPosters = [];
        if (checkAll) {
          if (this.items) {
            this.items.forEach((item) => this.selectedPosters.push(item));
          }
        }
      },

      query_poster: _.debounce(function () {
        this.currentPage = 1;
        this.items = [];
        this.fetchDataPosters();
      }, 500),

      'filters.status': function() {
        this.setFilter('status', this.filters.status);
        this.fetchData();
      },

      selectedPosters() {
        this.syncSelectedPosters();
      },
    },

    computed: {
      selectedPosters: {
        get() {
          return this.$store.getters['printPosters/getSelectedPosters'];
        },

        set(posterId) {
          this.$store.commit('printPosters/SET_POSTERS_SELECTED', posterId);
        },
      },

      queryFilters() {
        let query_filters = '';
        for (var filterName in this.filters) {
          if (this.filters.hasOwnProperty(filterName)) {
            query_filters += '&' + filterName + '=' + this.filters[filterName];
          }
        }
        return query_filters;
      },

      fetch_url() {
        let query_params = '';
        query_params = '?query=' + this.query;
        query_params += '&field=' + this.field;
        query_params += '&order=' + this.order;

        if (this.currentPage != 1) {
          query_params += '&page=' + this.currentPage;
        }

        query_params += this.queryFilters;

        const url = this.dataSource + query_params;
        return encodeURI(url);
      },

      fetch_url_posters() {
        let query_params = '';
        query_params = '?query=' + this.query_poster;
        query_params += '&field=' + this.field;
        query_params += '&order=' + this.order;

        if (this.currentPage != 1) {
          query_params += '&page=' + this.currentPage;
        }

        query_params += this.queryFilters;

        const url = this.dataSource + query_params;
        return encodeURI(url);
      },

      no_results() {
        return typeof this.items == 'undefined' || this.items.length == 0;
      },

      enabledNextPageButton() {
        return this.currentPage < this.totalPages;
      },

      enabledPrevPageButton() {
        return this.currentPage > 1;
      },

      shouldShowPagination() {
        return this.totalPages > 1;
      },

      isNotLoading() {
        return !this.loading;
      },
    },

    data() {
      return {
        items: [],

        loading: true,

        query: '',
        query_poster: '',
        field: '',
        order: 'desc',
        checkAll: false,

        totalPages: 1,
        currentPage: 1,
        itemsPerPage: 15,
        lastSearchCount: 1,

        count: {
          actives: 0,
          inactives: 0,
        },

        filters: {},

        periodOptions: [
          {name: 'Todos', value: 'always'},
          {name: 'Hoje', value: 'today'},
          {name: 'Ontem', value: 'yesterday'},
          {name: 'Esta semana', value: 'last-week'}
        ],

        printedOptions: [
          {name: 'Todos', value: 'all'},
          {name: 'Impressos', value: 'printed'},
          {name: 'Não Impressos', value: 'unprinted'},
        ],

        numberOfRecordsOptions: [
          {name: '25', value: 25},
          {name: '50', value: 50},
          {name: '75', value: 75},
          {name: '100', value: 100},
          {name: '150', value: 150},
          {name: '200', value: 200},
          {name: '250', value: 250},
          {name: '300', value: 300},
        ],

        imageOptions: [
          {name: 'Cartazes sem imagem', value: 0},
          {name: 'Cartazes com imagem', value: 1},
        ],

        bootboxButtons: {
          cancel: {
            label: 'Não',
            className: 'btn-outline-secondary',
          },
          confirm: {
            label: 'Sim',
            className: 'btn-secondary text-white',
          },
        },

        editingData: false,

        sourceTypeOptions: [
          {name: 'Todos', value: 'all'},
          {name: 'API', value: 'API'},
          {name: 'Manual', value: 'MANUAL'},
          {name: 'Mobile', value: 'MOBILE'},
          {name: 'Planilha', value: 'DATASHEET'},
          {name: 'Rascunho', value: 'DRAFT'},
        ],
      };
    },

    mounted() {
      this.listenFilters();
      this.listenLoadingEvents();
      this.fetchData();
      this.$root.$on('reload-data', () => this.fetchData());
      this.$root.$on('reset-data', () => {
        this.currentPage = 1;
        this.items = [];
        this.fetchData()
      });
      this.$root.$on('remove-current-item', (id) => {
        this.items = this.items.filter((item) => item.id != id);
      })
      this.$root.$on('DraftPosterBeingEdited', (payload) => {
        this.editingData = payload.isEditing;
      })
    },

    methods: {
      syncSelectedPosters: _.debounce(function () {
        const payload = { 'items': this.selectedPosters.map((poster) => poster.id)};
        axios.post(this.handleSelectedUrl, payload).catch(() => {})
      }, 300),

      searchQuery() {
        this.currentPage = 1;
        this.items = [];
        this.fetchData();
      },

      clearSearchQuery() {
        this.query = '';
        this.items = [];
        this.currentPage = 1;
        this.fetchData();
        this.query_poster = '';
      },

      togglePosterSelected(id) {
        if(screen.width < 540){
          return ;
        }
        if (this.selectedPosters.find((poster) => poster.id == id.id)) {
          this.selectedPosters = this.selectedPosters.filter((poster) => poster.id != id.id);
        } else {
          this.selectedPosters.push(id);
        }
      },

      orderBy(field, event) {
        this.field = field;
        this.items = [];
        this.currentPage = 1;
        this.toggleOrder();
        this.setOrderArrowIn(event.target);
        this.fetchData();
      },

      toggleOrder() {
        this.order = (this.order == 'asc') ? 'desc' : 'asc';
        return this.order;
      },

      setOrderArrowIn(element) {
        let defaultClass = '.order-arrow';
        let classToRemove = $(element).attr('class');

        let toQuery = classToRemove ? `.${classToRemove} > .order-arrow` : defaultClass;

        let arrows = Array.from(document.querySelectorAll(toQuery));

        arrows.forEach((node) => {
          node.parentNode.removeChild(node);
        });

        element.appendChild(this.getArrow());
      },

      getArrow() {
        let arrow_classes = '';
        if (this.order == 'asc') {
          arrow_classes = 'fa fa-angle-up order-arrow';
        } else {
          arrow_classes = 'fa fa-angle-down order-arrow';
        }

        const arrow = document.createElement('i');
        arrow.className = arrow_classes;

        return arrow;
      },

      getRef(ref) {
        return this.$refs[ref];
      },

      setPagination(fetched_data) {
        if (typeof fetched_data !== 'undefined') {
          if (fetched_data.meta !== undefined) {
            this.currentPage = fetched_data.meta.current_page;
            this.totalPages = this.currentPage + 1;
            this.itemsPerPage = fetched_data.meta.per_page;
          } else {
            this.currentPage = fetched_data.current_page;
            this.totalPages = this.currentPage + 1;
            this.itemsPerPage = fetched_data.per_page;
          }
        }
      },

      fetchDataPosters() {
        this.$root.$emit('start-loading');
        const localQuery = this.query_poster;

        axios.get(this.fetch_url_posters).then((response) => {
          if (localQuery === this.query_poster) {
            this.items = _.union(this.items, response.data.data);
            this.setPagination(response.data);
            this.$root.$emit('stop-loading');
            this.$nextTick().then(function() {
              let elementPopover = $('[data-toggle="popover"]');
              if(elementPopover && elementPopover.length > 0)
                elementPopover.popover();
            });

            this.lastSearchCount = response.data.data.length;
          }

          this.$root.$emit('posterDataListFetched');
        });
      },

      fetchData() {
        this.$root.$emit('start-loading');
        const localQuery = this.query;

        axios.get(this.fetch_url).then((response) => {
          if (localQuery === this.query) {
            this.items = _.union(this.items, response.data.data);
            this.setPagination(response.data);
            this.$root.$emit('stop-loading');
            this.$nextTick().then(function() {
              let elementPopover = $('[data-toggle="popover"]');
              if(elementPopover && elementPopover.length > 0)
                elementPopover.popover();
            });

            this.lastSearchCount = response.data.data.length;
          }

          this.$root.$emit('posterDataListFetched');
        });
      },

      fetchPrevPage() {
        if (this.enabledPrevPageButton) {
          this.currentPage = this.currentPage - 1;
          this.fetchData();
        }
      },

      fetchNextPage() {
        if (this.enabledNextPageButton) {
          this.currentPage = this.currentPage + 1;
          this.fetchData();
        }
      },

      handleDelete(link) {
        axios.delete(link).then((response) => {
          const status = response.data;
          if (status.type) {
            this.$snotify[status.type](status.message);
            this.fetchData();
          } else {
            this.$snotify.error('Action undefined');
          }
        });
      },

      handleResendEmail(link) {
        axios.get(link).then((response) => {
          const status = response.data;
          if (status.type) {
            this.$snotify[status.type](status.message);
            this.fetchData();
          } else {
            this.$snotify.error('Action undefined');
          }
        });
      },

      confirmDelete(link, message = undefined) {
        if (message == undefined) {
          message = this.deleteMessage;
        }

        this.$snotify.confirm(message, this.deleteTitle, {
          timeout: 5000,
          showProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          buttons: [
            {text: 'Sim', action: () => this.handleDelete(link), bold: false},
            {text: 'Não'},
          ],
        });
      },

      listenFilters() {
        this.loaderFilters();
        this.$on('setFilter', (payload) => {
          this.setFilter(payload.urlKey, payload.value);
          this.items = [];
          this.currentPage = 1;
          this.fetchData();
        });
      },

      loaderFilters() {
        const periodFilter = JSON.parse(localStorage.getItem('period'));
        const printFilter = JSON.parse(localStorage.getItem('print'));
        const recordsFilter = JSON.parse(localStorage.getItem('records'));
        const userIdFilter = JSON.parse(localStorage.getItem('user_id'));

        this.filters = {
          period: _.get(periodFilter, 'value', 'today'),
          print: _.get(printFilter, 'value', 'all'),
          records: _.get(recordsFilter, 'value', 50),
          user_id: _.get(userIdFilter, 'value', 0),
          poster_type: this.filterType || 'print',
        };
      },

      setFilter(name, value) {
        if (value) {
          this.$set(this.filters, name, value);
        } else {
          delete this.filters[name];
          this.filters = _.assign({}, this.filters);
        }
      },

      listenLoadingEvents() {
        const vm = this;
        const target = document.querySelector('#fetch-next-page');
        let observer = new IntersectionObserver(onIntersection, {});

        observer.observe(target);

        function onIntersection(entries) {
          entries.forEach(entry => {
            if (entry.intersectionRatio > 0 && vm.lastSearchCount > 0) {
              vm.fetchNextPage();
            }
          });
        }

        window.toInt = function toInt(event) {
          const charCode = (event.which) ? event.which : event.keyCode;
          if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            $(event.target).val(1);
            return false;
          }
          let input = $(event.target);

          if (input.val() >= 100) {
            input.val(100);
            return false;
          }
          return true;
        };

        this.$on('codeResult', (code) => {
          this.query = code;
          this.searchQuery();
        });
        this.$root.$on('start-loading', () => this.loading = true);
        this.$root.$on('stop-loading', () => this.loading = false);
        this.$root.$on('destroy-multiple-posters', () => this.destroyPosters());
      },

      showContent(id) {
        this.$emit('show-poster', id);
      },

      destroyDraftPosters() {
        if (this.selectedPosters.length === 0) {
          return bootbox.alert('Selecione ao menos um cartaz.');
        }

        let title = 'Excluir cartaz';
        let message = 'Ao excluir seu cartaz você não terá mais acesso a ele.';

        if (this.selectedPosters.length > 1) {
          title = 'Excluir cartazes';
          message = 'Ao excluir seus cartazes você não terá mais acesso a eles.';
        }

        bootbox.confirm({
          title: title,
          message: message,
          buttons: this.bootboxButtons,
          callback: (confirm) => {
            if (confirm) {
              let vm = this;
              this.$root.$emit('start-loading');
              $.ajax({
                type: 'POST',
                url: '/online/automation/posters/destroy-multiple',
                dataType: 'json',
                data: {posters: vm.selectedPosters.map((poster) => poster.id)},
                success: (response) => {
                  vm.currentPage = 1;
                  vm.selectedPosters = [];
                  vm.items = [];
                  vm.fetchData();
                  vm.$root.throwFlashMessage(response.type, response.message);
                },
                error: () => {
                  vm.$root.throwFlashMessage('danger', 'Não foi possível apagar os rascunhos de cartazes');
                },
              }).done(() => {
                vm.$root.$emit('stop-loading');
              });
            }
          },
        });
      },

      destroyPosters() {
        if (this.selectedPosters.length === 0) {
          return bootbox.alert('Selecione ao menos um cartaz.');
        }

        let title = 'Excluir cartaz';
        let message = 'Ao excluir seu cartaz você não terá mais acesso a ele.';

        if (this.selectedPosters.length > 1) {
          title = 'Excluir cartazes';
          message = 'Ao excluir seus cartazes você não terá mais acesso a eles.';
        }

        bootbox.confirm({
          title: title,
          message: message,
          buttons: this.bootboxButtons,
          callback: (confirm) => {
            if (confirm) {
              let vm = this;
              this.$root.$emit('start-loading');
              $.ajax({
                type: 'POST',
                url: '/online/destroyMultiple',
                dataType: 'json',
                data: {posters: vm.selectedPosters.map((poster) => poster.id)},
                success: (response) => {
                  vm.currentPage = 1;
                  vm.selectedPosters = [];
                  vm.items = [];
                  vm.fetchData();
                  vm.$root.throwFlashMessage(response.type, response.message);
                },
                error: () => {
                  vm.$root.throwFlashMessage('danger', 'Não foi possível apagar os cartazes');
                },
              }).done(() => {
                vm.$root.$emit('stop-loading');
              });
            }
          },
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/data-component/PostersDatalist.vue